import React from "react";
import { useNavigate } from "react-router-dom";
import { Store, MapPin, User, ChevronRight, Car } from "lucide-react";
import { formatINRShort } from "@/lib/format";

export const DealershipCard = ({ dealership, showOwner = false }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/dealerships/${dealership.id}`)}
      className="group flex w-full items-center gap-3 rounded-xl border border-border bg-card p-3.5 text-left shadow-card transition-shadow hover:shadow-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent text-accent-foreground">
        <Store className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate text-[15px] font-bold text-foreground">{dealership.name || "Untitled Dealership"}</h3>
          {dealership.oem_brand && (
            <span className="shrink-0 rounded-full bg-secondary px-2 py-0.5 text-[10px] font-semibold text-secondary-foreground">
              {dealership.oem_brand}
            </span>
          )}
        </div>
        <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-muted-foreground">
          {dealership.contact_person && <span>{dealership.contact_person}</span>}
          {dealership.city && (
            <span className="inline-flex items-center gap-1">
              <MapPin className="h-3 w-3" /> {dealership.city}
            </span>
          )}
        </div>
        <div className="mt-1.5 flex items-center gap-3 text-[11px] text-muted-foreground">
          <span className="inline-flex items-center gap-1">
            <Car className="h-3 w-3" /> <b className="tnum text-foreground">{dealership.total_leads ?? 0}</b> leads
          </span>
          {showOwner && dealership.owner_name && (
            <span className="inline-flex items-center gap-1">
              <User className="h-3 w-3" /> {dealership.owner_name}
            </span>
          )}
        </div>
      </div>
      <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground/50 transition-transform group-hover:translate-x-0.5" />
    </button>
  );
};
